const initialState = {
	list: [],
	page: 1,
	isListNext: false,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'PAYMENT_TICKET_RECEIVER_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.list = action.payload.list;
		newState.page = action.payload.page;
		newState.isListNext = action.payload.isListNext;
		newState.scrollPos = 0;
		return newState;
	}
	else {
		return state;
	}
}
